import React, { useRef, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, ButtonGroup, CircularProgress, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { H3, Span } from "components/typography/Typography";
import { UploadBulkUserDeactivate } from "services/https/fetchers";
import { notifySuccess } from "redux/actions/AlertActions";
import { useDispatch } from "react-redux";

export default function DeactivateUserDialog({ openDialog, setOpenDialog }) {
  const [file, setFile] = useState();
  const [status, setStatus] = useState(null);
  const [errMsg, setErrMsg] = useState("");

  const [loader, setLoader] = useState(false);
  const inputFile = useRef(null);

  const dispatch = useDispatch();

  const handleClose = () => {
    setOpenDialog(false);
    setFile(null);
    setStatus(null);
    setErrMsg("");
    setLoader(false);
  };

  const handleUpload = () => {
    setLoader(true);
    if (file) {
      setErrMsg("");
      UploadBulkUserDeactivate({ file: file })
        .then((res) => {
          dispatch(
            notifySuccess({
              msg: `Bulk users created successfully`,
            })
          );
        })
        .catch((err) =>
          setStatus({ success: false, msg: "Cannot create users" })
        )
        .finally(() => setLoader(false));
    } else {
      setErrMsg("No file Added");
      setLoader(false);
    }
  };

  const handleChange = (event) => {
    setFile(event.target.files[0]);
  };

  const onButtonClick = () => {
    // `current` points to the mounted file input element
    inputFile.current.click();
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleClose}
      sx={{
        marginBottom: "24px",
        "& .MuiDialog-root": {
          padding: "2em",
        },
        "& .MuiDialog-paper": {
          width: "456px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "32px",
          alignItems: "center",
        }}
      >
        <H3>{"Deactivate Bulk User"}</H3>
        <IconButton
          color="primary"
          aria-label="close"
          component="span"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <label>{"Select Excel Sheet"}</label>
        <ButtonGroup sx={{ width: "100%", marginTop: "1em" }}>
          <Button
            variant="outlined"
            onClick={onButtonClick}
            sx={{ width: "100%" }}
          >
            {file?.name ?? ""}
          </Button>
          <Button variant={"contained"} onClick={onButtonClick}>
            {"Browse"}
            <input
              id="file"
              ref={inputFile}
              type="file"
              hidden
              onChange={handleChange}
              accept=".xlsx, .xls"
            />
          </Button>
        </ButtonGroup>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", p: 4 }}>
        <Button
          variant={"contained"}
          sx={{ width: "156px" }}
          onClick={handleUpload}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Span>{"Deactivate"}</Span>
            {loader ? (
              <CircularProgress
                sx={{ color: "#fff", marginLeft: "5px" }}
                size={20}
              />
            ) : (
              ""
            )}
          </Box>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
